import React, {PureComponent} from 'react'
import Store from 'Store'
import {inject, observer} from 'mobx-react'
import Stretch from '../Model'
import history from 'helpers/History'
import {Table} from 'components'
import {loading} from 'elements/Loading'
import OperationLine from '../../OperationLines/Model'

interface Props {
  store?: Store
  streteches: Stretch[]
  operationLines: OperationLine[]
}

@inject('store')
@loading<Props>(props => {
  return [
    props.store!.stretches.read(),
    props.store!.operationLines.read()
  ]
})
@observer
export default class StretchesTable extends PureComponent<Props, object> {
  componentDidMount(): void {
  }

  handleSelectItem = (value: Stretch) => {
    history.push(`/stretches/${value.id}`)
  }

  handleCreate = () => {
    history.push(`/stretches/create`)
  }

  mapea = (stretches, operationLines) => {
    return stretches.map(item => {
      const operationLine = operationLines.filter(ol => {
        return ol.id === item.operationLine_id
      })[0]
      const operationLineString = 'operationLine'
      item[operationLineString] = operationLine? operationLine.name: ''
      // console.log('item', item)
      return item
    })
  }

  render() {
    const {stretches} = this.props.store!
    const {operationLines} = this.props.store!

    const headers = /*this.props.store!.UI.isDesktop*/
      /*?*/ ['operationLine','name', 'code', 'origin', 'destination', 'description']
      /*: ['name', 'code', 'origin', 'destination', 'operationLine_id', 'description']*/
    const mapeados = this.mapea(stretches.data, operationLines.data)
    // console.log('mapeados', mapeados)

    if (!(operationLines.data.length>0))
      return <div><text>No hay lineas de operación, por favor cree una antes</text> </div>

    return (
      <Table
        items={mapeados}
        header={headers}
        onSelectItem={this.handleSelectItem}
        onCreate={this.handleCreate}
        keyExtractor={(item: Stretch) => String(item.id)}
        loading={!stretches.loaded}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Stretches/container/StretchesTable.tsx